import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { fetchData, postData, updateData, deleteData } from '../../../apiService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, IconButton, Paper, TableContainer, Table, TableHead, TableBody, TableRow, TableCell } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import ArrowForward from '@mui/icons-material/ArrowForward';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';


const ItemDetail = () => {
    const { isAuthenticated, companyId, permissions, logout, token } = useAuth();
    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

    }, [isAuthenticated, companyId, token, logout]);

    const hasCreateMasterPermission = permissions.includes('Create Master');
    const hasEditMasterPermission = permissions.includes('Edit Master');
    const hasDeleteMasterPermission = permissions.includes('Delete Master');

    const { id } = useParams();
    const history = useHistory();
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [formData, setFormData] = useState({
        name: '',
        gstRate: '',
        isSubmit: false,
    });

    const [newRecordData, setNewRecordData] = useState({
        CategoryId: id,
        CompanyId: companyId,
        Name: '',
        Rate: '',
        GSTRate: FormData.GSTRate,
        Description: '',
    });

    const [updatedData, setUpdateData] = useState({
        CategoryId: id,
        Name: '',
        Rate: '',
        GSTRate: '',
        Description: '',
    });


    const [data, setData] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);

    useEffect(() => {
        fetchData('CategoryApi', `/CategoryDetails/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setFormData(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching Category Details:', error);
            });

        fetchItemData();
    }, [id]);

    const fetchItemData = async () => {
        try {
            const response = await fetchData('ItemApi', `/${id}`, token);
            if (response.responseCode === '1111') {
                setData(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching Item', error);
        }
    };

    const openDetailModal = async (item) => {
        try {
            const response = await fetchData('ItemApi', `/ItemDetails/${item.Id}`, token);
            if (response.responseCode === '1111') {
                setUpdateData(response.response_data);
                setIsDetailModalOpen(true);
            }
        } catch (error) {
            console.error('Error fetching Item Details:', error);
        }
    };



    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    const toggleModalBranch = () => {
        setIsDetailModalOpen(false); // Step 2
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setNewRecordData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleUpdateInputChange = (event) => {
        const { name, value } = event.target;
        setUpdateData((prevDataItem) => ({
            ...prevDataItem,
            [name]: value,
        }));
    };



    const addRecord = async () => {
        newRecordData.CategoryId = id;
        newRecordData.CompanyId = companyId;
        if (newRecordData.Name === '' || newRecordData.Rate === '') {
            console.error('Invalid data. Please fill all required fields.');
            return;
        }

        try {
            await postData('ItemApi', newRecordData, token);
            setNewRecordData({
                CategoryId: id,
                Name: '',
                Rate: '',
                GSTRate: '',
                Description: '',
            });
            fetchItemData();
            setIsModalOpen(false);
        } catch (error) {
            console.error('Item Create error:', error);
        }
    };

    const updateRecord = async (event) => {
        event.preventDefault();

        if (!updatedData) {
            console.error('No Item details selected.');
            return;
        }

        try {
            await updateData('ItemApi', `${updatedData.Id}`, updatedData, token);
            setUpdateData({
                CategoryId: id,
                Name: '',
                Rate: '',
                GSTRate: '',
                Description: '',
            });
            fetchItemData();
            setIsDetailModalOpen(false);
        } catch (error) {
            console.error('Error updating record:', error);
        }
    };

    const handleDelete = async () => {
        try {
            await deleteData('CategoryApi', `${deleteItemId}`, token);
            fetchItemData();
            setDeleteItemId(null);
            setConfirmDialogOpen(false);
        } catch (error) {
            console.error('Error deleting record:', error);
        }
    };

    const openConfirmDialog = (itemId) => {
        setDeleteItemId(itemId);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
    };

    return (
        <div className="w-full max-w-sm container mt-2 mx-auto">
            <div className="w-full mb-2 flex">
                <h5 className="productHead flex-grow linkcolor" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif',color:'black' }}> ITEM - DETAILS</h5>
                <Button
                    variant="contained"
                    color="error"
                    component={Link}
                    to="/ItemIndex"
                    className="linkcolor"
                    style={{ marginLeft: '8px' }}
                >
                    BACK TO LIST
                </Button>
            </div>

            {errorMessage && <p className="text-red-500">{errorMessage}</p>}
            {successMessage && <p className="text-green-500">{successMessage}</p>}

            <div className="flex">
                <div className="w-1/2 pr-4">
                    <div className="bg-blue-800 rounded-lg shadow-lg p-6">
                        <div className="w-full mb-4 flex">
                            <div className="w-4/5 mr-4">
                                <label className="block tracking-wide text-white text-base  mb-2" htmlFor="Name" style={{ fontSize: '14px' }}>
                                    ITEM NAME
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    name="Name"
                                    value={formData.name}
                                    type="text"
                                    placeholder="Enter Item Name"
                                    readOnly
                                />
                            </div>



                            <div className="w-1/5 mr-2">
                                <label className="block tracking-wide text-white text-base  mb-2" htmlFor="rate" style={{ fontSize: '14px' }}>
                                    GST RATE
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                    name="GSTRate"
                                    value={formData.gstRate}
                                    type="number"
                                    placeholder="Enter GST Rate"
                                    readOnly
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="w-1/2 pl-4">
                    <div className="bg-teal-700 rounded-lg shadow-lg p-6">
                        <div className="w-full mb-5 flex">
                            <h6 className="text-lg  mb-4 linkcolor mr-2">ITEM DETAILS</h6>
                            {hasCreateMasterPermission && (
                                <div className="ml-auto">
                                    <button className="bg-blue-500 text-white px-4 py-2 rounded" onClick={toggleModal}>
                                        Add Record
                                    </button>
                                </div>
                            )}


                            {isModalOpen && (
                                <div className="fixed inset-0 flex items-center justify-center z-10">
                                    <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '800px' }}>
                                        <div className="w-full mb-4">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="name">
                                                Item Name
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                                type="text"
                                                name="Name"
                                                placeholder="Enter Item name"
                                                value={newRecordData.Name}
                                                onChange={handleInputChange}
                                            />
                                        </div>

                                        <div className="w-full mb-4 flex">
                                            <div className="w-4/5 mr-4">
                                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="Description">
                                                    Description
                                                </label>
                                                <textarea
                                                    className="shadow appearance-none border rounded w-full h-20 py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                                    name="Description"
                                                    placeholder="Enter Description"
                                                    value={newRecordData.Description}
                                                    onChange={handleInputChange}
                                                />
                                            </div>



                                            <div className="w-1/10 mr-2">
                                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="ContactNumber1">
                                                    MRP
                                                </label>
                                                <input
                                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                                    type="text"
                                                    name="Rate"
                                                    placeholder="Enter MRP"
                                                    value={newRecordData.Rate}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                            <div className="w-1/10 mr-2">
                                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="ContactNumber2">
                                                    GST %
                                                </label>
                                                <input
                                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                                    type="text"
                                                    name="GSTRate"
                                                    placeholder="Enter GST Rate"
                                                    value={newRecordData.GSTRate}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                        </div>
                                        <div className="w-1/2 mr-4" style={{ marginTop: '23px' }}>
                                            <button className="bg-green-500 text-white px-4 py-2 rounded" onClick={addRecord}>
                                                Add Record
                                            </button>
                                            <button className="bg-blue-500 text-white px-4 py-2 rounded  ml-2" onClick={toggleModal}>
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className='w-full mb-5 flex' style={{ maxHeight: '400px', overflowY: 'auto',marginTop:'-25px' }}>
                            <TableContainer component={Paper}>
                                <Table>
                                    <TableHead sx={{ backgroundColor: '#f3f3f3' }}> {/* Set background color */}
                                        <TableRow>
                                            <TableCell sx={{ borderBottom: '1px solid #ddd' }}>NAME</TableCell>
                                            <TableCell sx={{ borderBottom: '1px solid #ddd' }}>RATE</TableCell>
                                            <TableCell sx={{ borderBottom: '1px solid #ddd' }}>ACTIONS</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {data && data.map(item => (
                                            <TableRow key={item.Id}>
                                                <TableCell className="customTableCell" sx={{ height: '40px', width: '350px', padding: '5px' }}>{item.Name}</TableCell>
                                                <TableCell className="customTableCell" sx={{ height: '40px', width: '100px', padding: '5px' }}>{item.Rate}</TableCell>
                                                <TableCell className="customTableCell" sx={{ height: '40px', padding: '5px' }}>

                                                    <IconButton onClick={() => openDetailModal(item)}>
                                                        <ArrowForward style={{color:'orange'}}/>
                                                    </IconButton>
                                                    {hasDeleteMasterPermission && (
                                                        <IconButton onClick={() => openConfirmDialog(item.Id)}>
                                                            <DeleteIcon style={{color:'red'}}/>
                                                        </IconButton>
                                                    )}

                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>

                                    {/* Delete confirmation dialog */}
                                    <Dialog
                                        open={confirmDialogOpen}
                                        onClose={closeConfirmDialog}
                                        aria-labelledby="alert-dialog-title"
                                        aria-describedby="alert-dialog-description"
                                    >
                                        <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                                        <DialogContent>
                                            <DialogContentText id="alert-dialog-description">
                                                Are you sure you want to delete this record?
                                            </DialogContentText>
                                        </DialogContent>
                                        <DialogActions>
                                            <button onClick={closeConfirmDialog} className="cancelbutton">
                                                Cancel
                                            </button>
                                            <button onClick={handleDelete} className="confirmbutton">
                                                Confirm
                                            </button>
                                        </DialogActions>
                                    </Dialog>
                                </Table>
                            </TableContainer>

                            {isDetailModalOpen && (
                                <div className="fixed inset-0 flex items-center justify-center z-10">
                                    <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '800px' }}> {/* Adjust width here */}

                                        <div className="w-full mb-4">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="name">
                                                Item Name
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                                type="text"
                                                name="Name"
                                                placeholder="Enter Item name"
                                                value={updatedData.Name}
                                                onChange={handleUpdateInputChange}
                                            />
                                        </div>

                                        <div className="w-full mb-4 flex">
                                            <div className="w-4/5 mr-4">
                                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="Description">
                                                    Description
                                                </label>
                                                <textarea
                                                    className="shadow appearance-none border rounded w-full h-20 py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                                    name="Description"
                                                    placeholder="Enter Description"
                                                    value={updatedData.Description}
                                                    onChange={handleUpdateInputChange}
                                                />
                                            </div>



                                            <div className="w-1/10 mr-2">
                                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="ContactNumber1">
                                                    MRP
                                                </label>
                                                <input
                                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                                    type="text"
                                                    name="Rate"
                                                    placeholder="Enter MRP"
                                                    value={updatedData.Rate}
                                                    onChange={handleUpdateInputChange}
                                                />
                                            </div>
                                            <div className="w-1/10 mr-2">
                                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="ContactNumber2">
                                                    GST %
                                                </label>
                                                <input
                                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                                    type="text"
                                                    name="GSTRate"
                                                    placeholder="Enter GST Rate"
                                                    value={updatedData.GSTRate}
                                                    onChange={handleUpdateInputChange}
                                                />
                                            </div>
                                        </div>

                                        <div className="w-1/2 mr-4" style={{ marginTop: '23px' }}>
                                            {hasEditMasterPermission && (
                                                <button className="bg-green-500 text-white px-4 py-2 rounded" onClick={updateRecord}>
                                                    Update Record
                                                </button>
                                            )}
                                            <button className="bg-blue-500 text-white px-4 py-2 rounded  ml-2" onClick={toggleModalBranch}>
                                                Cancel
                                            </button>
                                        </div>


                                    </div>
                                </div>
                            )}


                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ItemDetail;
